var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/home/viewmodels/dashboard',["require", "exports", "durandal/app", "models/account", "common/viewmodelbase"], function (require, exports, App, Account, ViewModel) {
    "use strict";
    var IndexViewModel = (function (_super) {
        __extends(IndexViewModel, _super);
        //#region ctor
        function IndexViewModel() {
            _super.call(this);
            //#endregion
            this.isAuthenticated = Account.Session.isAuthenticated;
            this.title = "home";
            ko.track(this, ["isAuthenticated"]);
            if (!Account.Session.isAuthenticated) {
                App.on('authentication', this.onAuthenticationChanged, this);
            }
        }
        IndexViewModel.prototype.onActivated = function (context) {
            this.isAuthenticated = Account.Session.isAuthenticated;
            return Q(true);
        };
        IndexViewModel.prototype.onAuthenticationChanged = function (value) {
            this.isAuthenticated = Account.Session.isAuthenticated;
        };
        return IndexViewModel;
    }(ViewModel.ViewModelBase));
    var instance = new IndexViewModel();
    return instance;
});

